import React from 'react';

import { COMMUNITIES } from '@lumapps/communities/keys';
import { COMMUNITY_ADMIN } from '@lumapps/community-admin/keys';
import { communitiesAdminRoute } from '@lumapps/community-admin/routes';
import { communitiesTemplatesRoute } from '@lumapps/community-templates/routes';
import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiGoogleCirclesExtended } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

export interface CommunitiesSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
    isTemplatesAllowed: boolean;
}

export const CommunitiesSideNavigation: React.FC<CommunitiesSideNavigationProps> = (props) => {
    const { isAllowed, isTemplatesAllowed, ...restOfProps } = props;

    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(COMMUNITIES.NAV)}
            icon={mdiGoogleCirclesExtended}
            id="communities"
        >
            <SideNavigationItem label={translateKey(COMMUNITIES.NAV)} route={communitiesAdminRoute} />
            {isTemplatesAllowed && (
                <SideNavigationItem label={translateKey(COMMUNITY_ADMIN.TEMPLATES)} route={communitiesTemplatesRoute} />
            )}
        </SideNavigationItem>
    );
};

CommunitiesSideNavigation.displayName = 'SideNavigationItem';
